import { FormControl, ValidationErrors } from "@angular/forms";

export function phoneValidator(control: FormControl): ValidationErrors {
	return !control.value || /(0)\d{9}/.test(control.value)
	  ? null
	  : { phone: true };
  }
  
  export function phoneValidationMessage(err, field) {
	return `"${field.formControl.value}" is not valid phone number`;
  }
  